import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import _typeof from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/typeof.js";
import _asyncToGenerator from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import "core-js/modules/es6.array.map.js";
import _regeneratorRuntime from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Service from "./Service";
var originalLog = console.log;
var originalError = console.error;
var originalWarn = console.warn;
var CollectableLogsService = /*#__PURE__*/function (_Service) {
  _inherits(CollectableLogsService, _Service);
  var _super = _createSuper(CollectableLogsService);
  function CollectableLogsService() {
    _classCallCheck(this, CollectableLogsService);
    return _super.apply(this, arguments);
  }
  _createClass(CollectableLogsService, [{
    key: "startCollectingLogs",
    value: function startCollectingLogs(collectableLogs) {
      console.log = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        collectableLogs.push({
          type: 'log',
          message: args
        });
        originalLog.apply(console, args);
      };
      console.error = function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        collectableLogs.push({
          type: 'error',
          message: args
        });
        originalError.apply(console, args);
      };
      console.warn = function () {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        collectableLogs.push({
          type: 'warn',
          message: args
        });
        originalWarn.apply(console, args);
      };
      window.addEventListener('error', function (event) {
        collectableLogs.push({
          type: 'error',
          message: event.message + " " + event.error
        });
      });
      window.addEventListener('unhandledrejection', function (event) {
        collectableLogs.push({
          type: 'unhandledrejection',
          message: event.reason
        });
      });
    }
  }, {
    key: "sendLogs",
    value: function () {
      var _sendLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(collectableLogs) {
        var _iterator, _step, log, body;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _iterator = _createForOfIteratorHelper(collectableLogs);
              _context.prev = 2;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context.next = 11;
                break;
              }
              log = _step.value;
              body = {
                "origin": "frontend",
                "errorMessage": this.processLogMessage(log.message),
                "type": log.type || "info",
                "createdAt": new Date().toISOString()
              };
              _context.next = 9;
              return this.post('log/internal', body, this.getHeaders().headers["Content-Type"].concat(";charset=UTF-8"));
            case 9:
              _context.next = 4;
              break;
            case 11:
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              _iterator.e(_context.t0);
            case 16:
              _context.prev = 16;
              _iterator.f();
              return _context.finish(16);
            case 19:
              _context.next = 24;
              break;
            case 21:
              _context.prev = 21;
              _context.t1 = _context["catch"](0);
              console.error('[LOG_SERVICE] Erro ao salvar log:', _context.t1);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 21], [2, 13, 16, 19]]);
      }));
      function sendLogs(_x) {
        return _sendLogs.apply(this, arguments);
      }
      return sendLogs;
    }()
  }, {
    key: "processLogMessage",
    value: function processLogMessage(message) {
      if (!message) {
        return "Mensagem não informada";
      }
      if (typeof message === 'string') {
        return message;
      }
      if (Array.isArray(message)) {
        if (message.length === 0) {
          return "Mensagem não informada";
        }

        // Check if array contains strings
        if (message.every(function (item) {
          return typeof item === 'string';
        })) {
          return message.join(' ');
        }

        // Check if array contains objects
        if (message.every(function (item) {
          return _typeof(item) === 'object' && item !== null;
        })) {
          return message.map(function (item) {
            return JSON.stringify(item);
          }).join(' ');
        }

        // Mixed array - stringify everything
        return message.map(function (item) {
          return typeof item === 'string' ? item : JSON.stringify(item);
        }).join(' ');
      }
      return "Mensagem não informada";
    }
  }]);
  return CollectableLogsService;
}(Service);
export default CollectableLogsService;